<template>
    <div id="membership-details-linked-members-tab"
         class="tab-contents">
        <PageLoadingSpinner v-if="loadingLinkedMembers"
                            color="light"
                            lang="MEMBERSHIP_DETAILS.LOADING" />

        <div v-if="linkedMembers !== null && linkedMembers.length > 0"
             class="linked-members">
            <div class="member-tiles">
                <MemberTile v-for="linkedMember in linkedMembers"
                            :key="linkedMember.member.ID"
                            :member="linkedMember.member"
                            :membership="linkedMember.membership"
                            :membership-subscription="linkedMember.membership.currentSubscription"
                            :show-membership-ref="true"
                            @toggle-visit="handleToggleVisit" />
            </div>
        </div>

        <div v-if="linkedMembers !== null && linkedMembers.length < 1"
             class="alert alert-info">
            {{ l('MEMBERSHIP_DETAILS.NO_LINKED_MEMBERS') }}
        </div>
    </div>
</template>

<script>
import MemberTile from '@/epos/vue/components/Memberships/MemberTile';
import PageLoadingSpinner from '@/vue/components/PageLoadingSpinner';
import { container } from '@/container';
import { suppressNotFoundApiErrorOrDisplay } from '@/lib/Errors';

export default {
    components: {
        MemberTile,
        PageLoadingSpinner,
    },

    props: {
        /**
         * @type {Membership}
         */
        membership: {
            type: Object,
            required: true,
        },
    },

    emits: ['toggle-visit'],

    data() {
        return {
            linkedMembers: null,
            loadingLinkedMembers: false,
        };
    },

    mounted() {
        this.loadLinkedMembers();
    },

    methods: {
        handleToggleVisit(member, membershipSubscription, membershipPlan, membership) {
            this.$emit('toggle-visit', member, membershipSubscription, membershipPlan, membership);
        },

        async loadLinkedMembers() {
            if (this.linkedMembers !== null) {
                return;
            }

            if (!this.membership.customerAccount) {
                return;
            }

            this.loadingLinkedMembers = true;

            try {
                const account = await container.customerAccountService.get(this.membership.customerAccount.ID);

                if (!account) {
                    this.linkedMembers = [];
                    this.loadingLinkedMembers = false;
                    return;
                }

                const linkedMembers = [];

                // Go through each membership and pick out the linked members to show
                for (let i = 0; i < account.memberships.length; i++) {
                    const linkedMembership = account.memberships[i];
                    if (linkedMembership.ID === this.membership.ID) {
                        continue;
                    }

                    if (!linkedMembership.isActive() || !linkedMembership.currentSubscription) {
                        continue;
                    }

                    for (let j = 0; j < linkedMembership.members.length; j++) {
                        const linkedMember = linkedMembership.members[j];
                        if (linkedMember.hasContact()) {
                            // Only show each person once
                            if (linkedMembers.find((lm) => lm.member.contactID === linkedMember.contactID)) {
                                continue;
                            }

                            // Hide contacts that are already present in the loaded membership
                            if (this.membership.getMemberByRef(linkedMember.contact.ref)) {
                                continue;
                            }

                            linkedMembers.push({
                                membership: linkedMembership,
                                member: linkedMember,
                            });
                        }
                    }
                }

                this.linkedMembers = linkedMembers;
                this.loadingLinkedMembers = false;
            } catch (e) {
                suppressNotFoundApiErrorOrDisplay(e);
                this.linkedMembers = [];
                this.loadingLinkedMembers = false;
            }
        },
    },
};
</script>
